import {CREATE_USER_SUCCESS, FETCH_USER_SUCCESS, GET_USER_SUCCESS, SAVE_USER_QUERY} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_USER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_USER_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_USER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
